import * as Location from './components/Location.module.css';

export default {
	Location
};
